// ---------------------------------------------------------------------------
// Texto das coordenadas de uma origem, para a etiqueta do marcador quando
// a origem está em foco ("Ir" no Info do modelo > Origens).
//
// Duas leituras do mesmo ponto, cada uma com o seu referencial dito:
//   - no ficheiro IFC: X, Y, Z em metros (já convertidos com a unidade de
//     comprimento do projecto; a origem do ficheiro é 0, 0, 0);
//   - no CRS, quando há georreferenciação aplicada: E, N, Cota.
//
// Puro: números a entrar, linhas de texto a sair.
// ---------------------------------------------------------------------------

/** 3 casas decimais, vírgula decimal, sem "-0,000". */
export function numeroDaOrigem(v: number): string {
  if (!Number.isFinite(v)) return '-'
  const t = v.toFixed(3)
  return (Number(t) === 0 ? t.replace('-', '') : t).replace('.', ',')
}

export function linhasDeCoordenadas(
  noFicheiro: readonly [number, number, number],
  noCrs: readonly [number, number, number] | null,
): string[] {
  const n = numeroDaOrigem
  const linhas = [
    `No ficheiro IFC: X ${n(noFicheiro[0])} · Y ${n(noFicheiro[1])} · Z ${n(noFicheiro[2])} m`,
  ]
  if (noCrs) {
    linhas.push(`No CRS: E ${n(noCrs[0])} · N ${n(noCrs[1])} · Cota ${n(noCrs[2])} m`)
  }
  return linhas
}
